const initializers = {
  householdAccountIds: "loadHouseholdAccounts",
  householdConnectionsIds: "loadHouseholdConnections",
  householdConnectionLinksIds: "loadHouseholdConnectionLinks",
  privileges: "loadPrivileges",
  subscriptions: "loadSubscriptions",
  householdBenefitIds: "loadHouseholdBenefits",
  householdEmployerIds: "loadHouseholdEmployers",
  householdScenarioIds: "loadHouseholdScenarios",
  householdIds: "loadUserHouseholdIds",
  households: "loadHousehold",
  incomeBreakdowns: "loadHouseholdIncomeBreakdown",
  spendingBreakdowns: "loadHouseholdSpendingBreakdown",
  householdIncomeIds: "loadHouseholdIncomesIds",
  householdPersonIds: "loadHouseholdPeople",
  householdPropertyIds: "loadHouseholdProperties",
  userState: "loadUserState",
  polls: "loadPoll",
  user: "loadUser",
  people: "loadPerson",
  accounts: "loadAccount",
  properties: "loadProperty",
  employers: "loadEmployer",
  incomes: "loadIncome",
  benefits: "loadBenefit",
  scenarios: "loadScenario",
  scenarioGoalIds: "loadScenarioGoals",
  goals: "loadGoal",
  scenarioProposalIds: "loadScenarioProposalStatuses",
  householdState: "loadHouseholdState",
  proposals: "loadProposal",
  methodology: "loadMethodology",
  agreements: "loadAgreements",
  agreementTexts: "loadAgreementContent",
  termsAndConditions: "loadTermsAndConditions",
  invite: "loadInvite",
  faqs: "loadFaq",
  latestProposalState: "loadLatestProposalState",
  householdOffers: "loadHouseholdOffers",
  interviews: "loadInterview",
  allMinicourses: "loadAllMinicourses",
  minicourses: "loadMinicourse",
  contextuals: "loadContextual"
}

export default initializers
